/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse20027,
    InlineResponse20027FromJSON,
    InlineResponse20027ToJSON,
    ReadOnlyMonitoredObjectSharing,
    ReadOnlyMonitoredObjectSharingFromJSON,
    ReadOnlyMonitoredObjectSharingToJSON,
    WriteOnlyMonitoredObjectSharing,
    WriteOnlyMonitoredObjectSharingFromJSON,
    WriteOnlyMonitoredObjectSharingToJSON,
} from '../models';

export interface MonitoredObjectSharingCreateRequest {
    data: WriteOnlyMonitoredObjectSharing;
}

export interface MonitoredObjectSharingDeleteRequest {
    id: string;
}

export interface MonitoredObjectSharingListRequest {
    limit?: number;
    offset?: number;
}

export interface MonitoredObjectSharingPartialUpdateRequest {
    id: string;
    data: WriteOnlyMonitoredObjectSharing;
}

export interface MonitoredObjectSharingReadRequest {
    id: string;
}

export interface MonitoredObjectSharingUpdateRequest {
    id: string;
    data: WriteOnlyMonitoredObjectSharing;
}

/**
 * no description
 */
export class MonitoredObjectSharingApi extends runtime.BaseAPI {

    /**
     */
    async monitoredObjectSharingCreateRaw(requestParameters: MonitoredObjectSharingCreateRequest): Promise<runtime.ApiResponse<ReadOnlyMonitoredObjectSharing>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling monitoredObjectSharingCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/monitored-object-sharing/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyMonitoredObjectSharingToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyMonitoredObjectSharingFromJSON(jsonValue));
    }

    /**
     */
    async monitoredObjectSharingCreate(requestParameters: MonitoredObjectSharingCreateRequest): Promise<ReadOnlyMonitoredObjectSharing> {
        const response = await this.monitoredObjectSharingCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async monitoredObjectSharingDeleteRaw(requestParameters: MonitoredObjectSharingDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling monitoredObjectSharingDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/monitored-object-sharing/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async monitoredObjectSharingDelete(requestParameters: MonitoredObjectSharingDeleteRequest): Promise<void> {
        await this.monitoredObjectSharingDeleteRaw(requestParameters);
    }

    /**
     */
    async monitoredObjectSharingListRaw(requestParameters: MonitoredObjectSharingListRequest): Promise<runtime.ApiResponse<InlineResponse20027>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/monitored-object-sharing/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20027FromJSON(jsonValue));
    }

    /**
     */
    async monitoredObjectSharingList(requestParameters: MonitoredObjectSharingListRequest): Promise<InlineResponse20027> {
        const response = await this.monitoredObjectSharingListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async monitoredObjectSharingPartialUpdateRaw(requestParameters: MonitoredObjectSharingPartialUpdateRequest): Promise<runtime.ApiResponse<ReadOnlyMonitoredObjectSharing>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling monitoredObjectSharingPartialUpdate.');
        }

        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling monitoredObjectSharingPartialUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/monitored-object-sharing/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyMonitoredObjectSharingToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyMonitoredObjectSharingFromJSON(jsonValue));
    }

    /**
     */
    async monitoredObjectSharingPartialUpdate(requestParameters: MonitoredObjectSharingPartialUpdateRequest): Promise<ReadOnlyMonitoredObjectSharing> {
        const response = await this.monitoredObjectSharingPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async monitoredObjectSharingReadRaw(requestParameters: MonitoredObjectSharingReadRequest): Promise<runtime.ApiResponse<ReadOnlyMonitoredObjectSharing>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling monitoredObjectSharingRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/monitored-object-sharing/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyMonitoredObjectSharingFromJSON(jsonValue));
    }

    /**
     */
    async monitoredObjectSharingRead(requestParameters: MonitoredObjectSharingReadRequest): Promise<ReadOnlyMonitoredObjectSharing> {
        const response = await this.monitoredObjectSharingReadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async monitoredObjectSharingUpdateRaw(requestParameters: MonitoredObjectSharingUpdateRequest): Promise<runtime.ApiResponse<ReadOnlyMonitoredObjectSharing>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling monitoredObjectSharingUpdate.');
        }

        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling monitoredObjectSharingUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/monitored-object-sharing/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyMonitoredObjectSharingToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyMonitoredObjectSharingFromJSON(jsonValue));
    }

    /**
     */
    async monitoredObjectSharingUpdate(requestParameters: MonitoredObjectSharingUpdateRequest): Promise<ReadOnlyMonitoredObjectSharing> {
        const response = await this.monitoredObjectSharingUpdateRaw(requestParameters);
        return await response.value();
    }

}
